
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './components/Header/Header';
import Banner from './components/banner/Banner';
import WhoWeAre from './components/WhoWeAre/WhoWeAre';
import WhatWeDo from './components/WhatWeDo/WhatWeDo';
import Skills from './components/Skills/Skills';
import Affiliations from './components/Affiliations/Affiliations';
import Fotter from './components/Footer/Fotter';
import HomePage from "./components/HomePage/HomePage";
import About from "./components/About/About";
import SeviceBanner from "./components/banner/SeviceBanner";
import Service from "./components/Services/Service";
import Portfolio from "./components/Portfolio/Portfolio";
import PortfolioDetail from "./components/Portfolio/PortfolioDetail";
import Clients from "./components/Clients/Clients";
import Contact from "./components/Contact/Contact";
// import About from './components/About/About'; // Create this About page
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function App() {
  return (
    <Router>
       <ScrollToTop />
      <Header />

      <Routes>
        <Route
          path="/"
          element={
            <HomePage />
          }
        />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/Portfolio" element={<Portfolio />} />
        <Route path="/portfolio/:id" element={<PortfolioDetail />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/contact" element={<Contact />} />


      </Routes>

      <Fotter />
      <ToastContainer position="top-right" autoClose={3000} />
    </Router>
  );
}

export default App;

